/* global window */
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { registerApplicationElement } from '@markit/web-component-bootstrap';
import configureStore from 'SiteConfigs/configureStore';
import { requestUserInfo } from 'Actions/UserActions';

import { updateLanguage, ComponentWrapper } from 'WebComponentEntryPoints/common';
import WcAccountHoldingsDrawer from 'components/WCAccountHoldingsDrawer/WcAccountHoldingsDrawer';
import getTokenPromise from '../getTokenPromise';

const { MD } = window;

// This is a copy of the generic function
// except for adding a wrapper to watch for and update the symbol
const customMountToElementBuilder = reactComponent => (
	el, { mdComponent, attributeChangedEventManager }
) => {
	const AccountHoldingsDrawerWrapper = () => {
		const [symbol, setSymbol] = useState(mdComponent.getAttribute('symbol'));
		const [country, setCountry] = useState(mdComponent.getAttribute('country'));
		const [venueXid, setVenueXid] = useState(mdComponent.getAttribute('venuexid'));
		attributeChangedEventManager.addEventHandler('symbol', value => setSymbol(value));
		attributeChangedEventManager.addEventHandler('country', value => setCountry(value));
		attributeChangedEventManager.addEventHandler('venuexid', value => setVenueXid(value));
		return React.cloneElement(reactComponent, { symbol, country, venueXid });
	};

	let instance = <></>;
	getTokenPromise().then(() => {
		const storeConfiguration = configureStore();

		if (MD && MD.apiBaseCibcUrl) {
			// make the request for the user info.
			storeConfiguration.store.dispatch(requestUserInfo());
		}

		updateLanguage(storeConfiguration.store, mdComponent.getAttribute('language') || 'en');
		attributeChangedEventManager.addEventHandler('language', value => updateLanguage(storeConfiguration.store, value || 'en'));


		instance = (
			<ComponentWrapper storeConfiguration={storeConfiguration}>
				<AccountHoldingsDrawerWrapper />
			</ComponentWrapper>
		);

		ReactDOM.render(instance, el);
	});

	return instance;
};

export default () => {
	registerApplicationElement(
		'md-account-holdings-drawer',
		{
			mountToElement: customMountToElementBuilder(<WcAccountHoldingsDrawer />)
		}
	);
};
